export enum GrowthBookFeatures {
  ALL_TOURS_COMPONENT = 'all-tours-component',
  CHOOSE_FLIGHTS = 'choose-flights-to-continue',
  TERMS_CONDITIONS_MODAL = 'terms-conditions-modal',
  WHATS_INCLUDED = 'hotel-landing-whats-included'
}
